import dayjs from 'dayjs';

const calculateDuration = (departureDateTime, arrivalDateTime) => {
  try {
    const departDate = dayjs(departureDateTime).startOf('day');
    const arriveDate = dayjs(arrivalDateTime).startOf('day');
    const isArrivingLater = arriveDate.isAfter(departDate);
    const durationInDays = arriveDate.diff(departDate, 'day');
    return isArrivingLater && durationInDays ? `+${durationInDays}` : undefined;
  } catch (e) {
    return undefined;
  }
};

export default calculateDuration;
